"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthorizationCodeTokenClient = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = require("@ori/axios");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _constants = require("./constants");
var _OidcTokenStorage = require("./storage/OidcTokenStorage");
var _OidcIdToken = require("./tokens/OidcIdToken");
var _OidcToken = require("./tokens/OidcToken");
var _singleton = require("./utils/singleton");
var _class, _AuthorizationCodeTokenClient;
let AuthorizationCodeTokenClient = exports.AuthorizationCodeTokenClient = (0, _singleton.singleton)(_class = (_AuthorizationCodeTokenClient = class AuthorizationCodeTokenClient {
  constructor(options) {
    (0, _defineProperty2.default)(this, "options", void 0);
    (0, _defineProperty2.default)(this, "storage", void 0);
    this.options = options;
    this.storage = this.options.storage ?? new _OidcTokenStorage.OidcTokenStorage();
  }
  async initializeTokenFromAuthorizationCode() {
    const authCode = this.storage.authorizationCode.get();
    if (!authCode) {
      throw new Error(`Auth - missing authorization code`);
    }
    const authCodeTokenData = await this.requestToken(authCode);
    const accessToken = new _OidcToken.OidcToken(authCodeTokenData.access_token);
    const user = accessToken.getClaim('consultant_number') ?? accessToken.getClaim('preferred_username') ?? _constants.UNKNOWN_USER;
    this.storage.setAccessToken({
      // Create expiration date manually,
      // because we wont get exact time that token expires,
      // but just only expires_in
      ExpirationDate: new Date(Date.now() + authCodeTokenData.expires_in * 1000).toString(),
      Token: authCodeTokenData.access_token,
      User: user
    });

    // Simulate the same behavior as Online login.
    _jsCookie.default.set(_constants.LOGGED_IN_USER_COOKIE, user);
    const idToken = new _OidcIdToken.OidcIdToken(authCodeTokenData.id_token);
    this.storage.setIdToken(idToken);
    this.storage.authorizationCode.remove();
    return true;
  }
  async requestToken(authCode) {
    try {
      const redirectUri = this.storage.redirectUri.get();
      if (!redirectUri) {
        throw new Error(`Redirect URI is missing`);
      }
      const codeVerifier = this.storage.codeVerifier.get();
      if (!codeVerifier) {
        throw new Error(`Code verifier is missing`);
      }
      const tokenRequest = fetch(new _axios.SafeURL('/connect/token', this.options.identityUrl || window.location.origin), {
        ...AuthorizationCodeTokenClient.REQUEST_OPTIONS,
        body: new URLSearchParams({
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
          client_id: this.options.clientId,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
          grant_type: 'authorization_code',
          code: authCode,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
          redirect_uri: redirectUri,
          // eslint-disable-next-line @typescript-eslint/naming-convention -- Identity server contract
          code_verifier: codeVerifier
        })
      });
      const response = await tokenRequest;
      if (!response.ok) {
        throw new Error(`${response.status} ${response.statusText}`);
      }
      const result = response.json();
      return result;
    } catch (error) {
      throw new Error(`Token request has failed: ${error}`);
    }
  }
}, (0, _defineProperty2.default)(_AuthorizationCodeTokenClient, "REQUEST_OPTIONS", {
  credentials: 'same-origin',
  headers: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'X-Fetch-Api': '1',
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'X-Requested-With': 'XMLHttpRequest',
    // eslint-disable-next-line @typescript-eslint/naming-convention -- HTTP header name
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  method: 'POST'
}), _AuthorizationCodeTokenClient)) || _class;
//# sourceMappingURL=AuthorizationCodeTokenClient.js.map